



















































































import {
  defineComponent,
  ref,
  useRoute,
  useRouter,
} from '@nuxtjs/composition-api';
import { SfButton } from '~/components/StorefrontUi';
import { SHOP_EMAIL, SHOP_TITLE, SHOP_PHONE } from '~/config/base';
import { addBasePath } from '~/helpers/addBasePath';
import { IconSingleArrowLeft } from '../General/icons';

export default defineComponent({
  name: 'SecondaryFooter',
  components: {
    SfButton,
    IconSingleArrowLeft,
  },
  props: {
    showBackButton: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isReturnURL = ref(!!route.value.query?.returnURL);

    return {
      route,
      isReturnURL,
      router,
      addBasePath,
      SHOP_TITLE,
      SHOP_EMAIL,
      SHOP_PHONE,
    };
  },
  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
    };
  },
});
